import { useEffect, useState } from 'react';

const START_DATE_FIELD = 'startDateBefristet';
const END_DATE_FIELD = 'endDateBefristet';

/**
 * Tracks the start date of the "befristet" range. When the user changes it, the end date is
 * cleared and the days between today and the start date are exposed for the end date's range.
 */
export const useBefristetEndDateReset = ({ form, isActive }) => {
    const [startDateRange, setStartDateRange] = useState(0);

    const { dirty, value: startDateValue } = form.getFieldState(START_DATE_FIELD) || {};
    const { date: startDateBefristetDate } = startDateValue || { date: '' };
    const startDateBefristetDateStr = startDateBefristetDate.toString();

    useEffect(() => {
        if (!isActive) return;
        if (!dirty) return;
        const {
            value: { date },
        } = form.getFieldState(START_DATE_FIELD);

        const daysBetween = Math.round((new Date(date) - new Date()) / (1000 * 60 * 60 * 24));
        setStartDateRange(daysBetween);

        form.change(END_DATE_FIELD, undefined);

        setTimeout(() => {
            form.resetFieldState(END_DATE_FIELD);
        }, 100);
    }, [dirty, isActive, startDateBefristetDateStr]);

    return { startDateRange, startDateBefristetDateStr };
};
